import React from 'react';
import BuyerCard from '../components/BuyerCard';
import LookbookGallery from '../components/LookbookGallery';
import DealershipSection from '../components/DealershipSection';
import company from '../data/company';
import { generateGeneralWhatsAppLink } from '../data/products';
import { MessageSquare } from 'lucide-react';
import { PRODUCT_IMAGES } from '../data/images';

const GlobalBusiness = () => {
  const steps = [
    {
      step: '01',
      title: 'TELL US YOUR REQUIREMENTS',
      description: 'Share your target style preferences, target volumes, market destination, and timeline expectations.'
    },
    {
      step: '02',
      title: 'DISCUSS THE COLLECTION',
      description: 'Review our curated denim lines or present your specific custom fit and wash technical samples.'
    },
    {
      step: '03',
      title: 'REVIEW PRODUCT DETAILS',
      description: 'Examine detailed fabric specs, seam construction standards, bar-tacking points, and trim options.'
    },
    {
      step: '04',
      title: 'DISCUSS CORPORATE REQUIREMENTS',
      description: 'Align on order parameters, batch packaging specifications, shipping terms, and corporate structure.'
    },
    {
      step: '05',
      title: 'MOVE FORWARD',
      description: 'Finalize production approval and dispatch staged consignments directly to your designated global port.'
    }
  ];

  return (
    <div style={{ paddingTop: 'calc(var(--nav-height) + 0px)', paddingBottom: '100px' }}>

      {/* Full-width Hero Image Banner */}
      <section style={{ position: 'relative', width: '100%', height: 'clamp(260px, 40vw, 480px)', overflow: 'hidden', marginBottom: '0' }}>
        <img
          src={PRODUCT_IMAGES[3]}
          alt="RAYYAN DENIM Global Business"
          fetchpriority="high"
          loading="eager"
          decoding="async"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center center', display: 'block' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(15,23,42,0.3) 0%, rgba(15,23,42,0.75) 100%)' }} />
        <div style={{ position: 'absolute', bottom: '32px', left: '0', right: '0' }}>
          <div className="container">
            <span className="section-badge" style={{ background: 'rgba(255,255,255,0.15)', borderColor: 'rgba(255,255,255,0.4)', color: '#ffffff' }}>INTERNATIONAL CORPORATE PORTAL</span>
            <h1 style={{ fontSize: 'clamp(32px, 5vw, 60px)', fontFamily: 'var(--font-heading)', fontWeight: 900, textTransform: 'uppercase', color: '#ffffff', marginTop: '10px' }}>
              BUILT FOR <span style={{ color: 'var(--accent-magenta)' }}>GLOBAL BUYERS</span>
            </h1>
            <p style={{ fontSize: 'clamp(15px, 1.8vw, 19px)', color: 'rgba(255,255,255,0.85)', maxWidth: '720px', lineHeight: '1.5', marginTop: '8px' }}>
              <span className="brand-name">RAYYAN DENIM</span> is structured for malls, multi-brand outlets (MBOs), retail store chains, importers, distributors, and apparel brands seeking dependable denim sourcing.
            </p>
          </div>
        </div>
      </section>

      {/* Target Buyer Audiences Grid */}
      <section style={{ padding: '60px 0', borderTop: '1px solid rgba(15, 23, 42, 0.08)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 48px' }}>
            <h2 className="section-title">
              WHO WE <span className="gradient-text">SERVE</span>
            </h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '16px' }}>
              Customized sourcing, order handling, and replenishment support for every retail procurement segment.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '28px' }}>
            {company.targetAudience.map((buyer) => (
              <BuyerCard key={buyer.id} item={buyer} />
            ))}
          </div>
        </div>
      </section>

      {/* Global Dealership & Distributorship Section */}
      <DealershipSection />

      {/* Lookbook Gallery */}
      <LookbookGallery />

      {/* The 5-Step Sourcing Journey */}
      <section style={{ padding: '80px 0', background: '#ffffff', borderTop: '1px solid rgba(15, 23, 42, 0.06)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 60px' }}>
            <span className="section-badge">ORDER WORKFLOW</span>
            <h2 className="section-title">
              HOW TO START A <span className="gradient-text">CORPORATE ENQUIRY</span>
            </h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '16px' }}>
              A simple, transparent 5-step process from initial contact to consignment dispatch.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px' }}>
            {steps.map((item) => (
              <div key={item.step} className="glass-panel" style={{ padding: '28px 24px', position: 'relative' }}>
                <div style={{ fontSize: '13px', fontWeight: 900, color: 'var(--accent-magenta)', letterSpacing: '0.1em', marginBottom: '12px' }}>
                  STEP {item.step}
                </div>
                <h3 style={{ fontSize: '16px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', marginBottom: '10px', textTransform: 'uppercase', fontWeight: 800 }}>
                  {item.title}
                </h3>
                <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: '1.5' }}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '48px' }}>
            <a
              href={generateGeneralWhatsAppLink("Global Corporate Sourcing Journey")}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ padding: '16px 36px' }}
            >
              <MessageSquare size={18} />
              INITIATE STEP 01 ON WHATSAPP
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default GlobalBusiness;
